module.exports = __webpack_public_path__ + "img/automaticas.965cb9b6.png";